import { Component, inject, OnInit } from "@angular/core";
import { Browser } from "@capacitor/browser";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { MenuController, NavController, Platform } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { ExternalLinks } from "src/app/services/dto/orwi-store";
import { GlobalService } from "src/app/services/global.service";
import { OrwiService } from "src/app/services/orwi.service";
import { UserService } from "src/app/services/user/user.service";
import { UIStore } from "src/app/state/ui/ui.store";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  translocoService = inject(TranslocoService);
  us = inject(UserService);
  nav = inject(NavController);
  uiStore = inject(UIStore);
  glb = inject(GlobalService)
  orwiService = inject(OrwiService);
  appVersion;
  isIstanbulSenin = localStorage.getItem("isIstanbulApp") ?? false;
  langs: string[] = ["tr", "en"];
  menus = [];
  links: ExternalLinks[] = [];
  constructor(private menuCtrl: MenuController, public platform:Platform) {}

  ngOnInit() {
    this.appVersion = environment.appVersion;
    this.getExternalLinks();
  }

  login() {
    this.us.afterLoginFunction = undefined;
    this.nav.navigateForward("otp-request");
  }

  writeUs() {
    this.menuCtrl.close()
    this.uiStore.update({ orwiContactVisible: true });
  }

  navigateToBeltur() {
    this.nav.navigateForward('/about-beltur');
  }

  logout() {
    this.us.logout();
  }

  goUrl(id) {
    Browser.open({
      url: this.links.find((e) => e.id == id).url,
    });
  }

  menulink(item) {
    this.glb.orwiContent = item;
    this.nav.navigateForward("browser");
  }

  openAppDev() {
    // this.startNum++;
    // console.log(this.startNum);
    // if (this.startNum > 10) {
    //   // alert(JSON.stringify(localStorage));
    // }
  }

  langChange(e) {
    console.log(e);
    localStorage.setItem("activeLang", e.detail.value);
    this.translocoService.setActiveLang(e.detail.value);
  }

  async getExternalLinks() {
    this.orwiService
      .serviceRequestPromise("/api/helper/getAppLinks", {})
      .then((l: any) => {
        console.log(l);
        this.links = l.response;
      });
  }

  async takePicture() {
    const image = await Camera.getPhoto({
      quality: 70,
      allowEditing: true,
      resultType: CameraResultType.Base64,
      presentationStyle: "popover",
      width: 600,
      height: 600,
      promptLabelHeader: this.translocoService.translate(
        "Camera Prompt Label Header"
      ),
      promptLabelPicture: this.translocoService.translate(
        "Camera Prompt Label Picture"
      ),
      promptLabelPhoto: this.translocoService.translate(
        "Camera Prompt Label Photo"
      ),
      source: CameraSource.Prompt,
    });

    this.glb.showLoading("");
    var imageUrl = image.base64String;
    let img: any = document.getElementById("imgElement");
    this.us.user.image = "data:image/png;base64," + imageUrl;
    await this.us.saveUser();
    img.src = this.us.user.image;
    this.glb.closeLoading();
  }

  log() {
    console.log("clicked!");
    this.nav.navigateForward('/profile-home')
  }

  closeMenu(){
    if(!this.platform.is('desktop')){
      this.menuCtrl.close()
    }
  }
}
